"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function updateSessionsCompleted({ sessionsCompleted }, sessionEvent) {
    return sessionsCompleted + 1;
}
exports.default = updateSessionsCompleted;
